import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from './styles';

export const SignatureSection = ({ data, type, isFinalSignature=false }) => {
    const t = data?.tenant || {};
    const lr = data?.legal_rep || {};
    const g = data?.guarantor || {};

    // Date formatting
    const today = new Date();
    const day = today.getDate();
    const month = today.toLocaleString('es-MX', { month: 'long' });
    const year = today.getFullYear();
    const dayName = today.toLocaleString('es-MX', { weekday: 'long' });
    const formattedDateNumeric = today.toLocaleDateString('es-MX'); // 21/11/2025

    // "21/11/2025 viernes, 21 de noviembre de 2025"
    const dateString = `${formattedDateNumeric} ${dayName}, ${day} de ${month} de ${year}`;


    return (
        <>
            {/* Date Section */}
            <View style={{ marginTop: type === 'PF' ? 140 : 0 }}>
                {!isFinalSignature ? (
                    <Text style={{ fontSize: 13, fontWeight: 'bold', marginBottom: 0, textAlign: 'left', color: '#34C6F1' }}>
                        FECHA DE LA CONFIRMACIÓN Y SUSCRIPCIÓN DE LA CARÁTULA Y CONTRATO
                    </Text>
                ) : (
                    <Text style={{ fontSize: 12, fontWeight: 'bold', marginBottom: 0, textAlign: 'left' }}>
                        Leído que fue por ambas Partes y enteradas de su contenido y fuerza legal, firman el presente Contrato en el Estado de México a: {dateString}
                    </Text>
                )}
                <Text style={{ fontSize: 8, textAlign: 'right' }}>
                    {!isFinalSignature && 'Estado de México a: ' + dateString}
                </Text>
            </View>

            {/* Signature Blocks */}
            <View style={{ marginTop: type === 'PF' ? 40 : 30 }}>
                {type === 'PF' ? (
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                        {/* Arrendatario PF */}
                        <View style={styles.signatureBlock}>
                            <Text style={styles.signatureTitle}>EL "ARRENDATARIO"</Text>
                            <View style={styles.signatureNameContainer}>
                                <Text style={styles.signatureText}>{t.nombreArrendatario}</Text>
                                <Text style={{ fontSize: 8, textAlign: 'center', fontFamily: 'Helvetica', textDecoration: 'underline' }}>Apoderado Legal</Text>
                                <Text style={styles.signatureSubtext}>POR SU PROPIO DERECHO</Text>
                            </View>
                        </View>

                        {/* Arrendador */}
                        <View style={styles.signatureBlock}>
                            <Text style={styles.signatureTitle}>EL "ARRENDADOR"</Text>
                            <View style={styles.signatureNameContainer}>
                                <Text style={styles.signatureText}>Conduce Capital SAPI de C.V.</Text>
                                <Text style={styles.signatureText}>Abraam Bonilla Sagahon</Text>
                                <Text style={{ fontSize: 8, textAlign: 'center', fontFamily: 'Helvetica', textDecoration: 'underline' }}>Apoderado Legal</Text>
                            </View>
                        </View>
                    </View>
                ) : (
                    <View>
                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 10, alignItems: 'center' }}>
                            {/* Arrendatario PM */}
                            <View style={styles.signatureBlock}>
                                <Text style={styles.signatureTitle}>EL "ARRENDATARIO"</Text>
                                <View style={styles.signatureNameContainer}>
                                    <Text style={styles.signatureText}>{t.empresa || t.nombreArrendamiento || 'empresa'}</Text>
                                    <Text style={styles.signatureText}>{lr.nombre}</Text>
                                    <Text style={{ fontSize: 8, textAlign: 'center', fontFamily: 'Helvetica', textDecoration: 'underline' }}>Apoderado Legal</Text>
                                </View>
                            </View>

                            {/* Obligado Solidario */}
                            <View style={styles.signatureBlock}>
                                <Text style={styles.signatureTitle}>EL "OBLIGADO SOLIDARIO"</Text>
                                <View style={styles.signatureNameContainer}>
                                    <Text style={styles.signatureText}>{g.nombre}</Text>
                                    <Text style={styles.signatureSubtext}>POR SU PROPIO DERECHO</Text>
                                </View>
                            </View>
                        </View>

                        {/* Arrendador PM */}
                        <View style={{ flexDirection: 'row', justifyContent: 'center', marginBottom: 10, alignItems: 'center', width: '100%' }}>
                            <View style={styles.signatureBlock}>
                                <Text style={styles.signatureTitle}>EL "ARRENDADOR"</Text>
                                <View style={styles.signatureNameContainer}>
                                    <Text style={styles.signatureText}>Conduce Capital SAPI de C.V.</Text>
                                    <Text style={styles.signatureText}>Abraam Bonilla Sagahon</Text>
                                    <Text style={{ fontSize: 8, textAlign: 'center', fontFamily: 'Helvetica', textDecoration: 'underline' }}>Apoderado Legal</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                )}
            </View>
        </>
    );
};
